/* eslint-disable */

const wcag = () => {
  const wcagContrastIcon = document.querySelectorAll('.js-wcag-contrast');
  const wcagFontIcon = document.querySelectorAll('.js-wcag-font-size');

  const setCookie = (cName, cValue, expDays) => {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }
  

  wcagContrastIcon.forEach(el => {
    el.addEventListener("click", (e)=>{
      if (document.documentElement.classList.contains("wcag-contrast")) {
        setCookie('wcag-contrast', '0', '30')
        document.documentElement.classList.remove("wcag-contrast");
        return;
      }
  
      setCookie('wcag-contrast', '1', '30');
      document.documentElement.classList.add("wcag-contrast");
    });
  })


  wcagFontIcon.forEach(el => {
    el.addEventListener("click", (e)=>{
      console.log("elo");
  
      if (document.documentElement.classList.contains("wcag-font-size--20")) {
        setCookie('wcag-font-size', '0', '30')
        document.documentElement.classList.remove("wcag-font-size--20");
        return;
      }
  
      if (document.documentElement.classList.contains("wcag-font-size--15")) {
        setCookie('wcag-font-size', '20', '30')
        document.documentElement.classList.remove("wcag-font-size--15");
        document.documentElement.classList.add("wcag-font-size--20");
        return;
      }
      
      setCookie('wcag-font-size', '15', '30');
      document.documentElement.classList.add("wcag-font-size--15");
    });
  })
};

export default wcag;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/wcag.js